module.exports = __webpack_public_path__ + "f88935165e87362689278e49bba0d622.svg";